// extracted by mini-css-extract-plugin
module.exports = {"SearchPanel":"pt_a bht_cw bht_jx bht_jo bht_a bht_j bht_ri bht_rj","SearchPanel__icon":"pt_b bht_ui bht_hb bht_ro bht_tu","SearchPanel__input":"pt_c bht_iv bht_cx bht_z"};